import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Mountain } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const inputCls =
    "rounded-none border-[#2c332f] bg-[#0d110f] text-[#f2efeb] h-12 focus-visible:ring-[#ba5a45] focus-visible:ring-1";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("aruha_admin_token", data.token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-[#0d110f] px-6">
      <div className="w-full max-w-md">
        <div className="mb-10 text-center">
          <Mountain className="mx-auto h-8 w-8 text-[#ba5a45]" />
          <div className="mt-4 font-serif text-3xl text-[#f2efeb]">Aruha Trails</div>
          <div className="overline mt-2">Admin Access</div>
        </div>
        <form onSubmit={submit} className="space-y-5 border border-[#242a27] bg-[#151a18] p-8">
          <div className="space-y-1.5">
            <Label className="text-[11px] uppercase tracking-[0.18em] text-[#a1a8a4]">Email</Label>
            <Input
              data-testid="admin-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={inputCls}
              placeholder="admin@aruhatrails.com"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[11px] uppercase tracking-[0.18em] text-[#a1a8a4]">Password</Label>
            <Input
              data-testid="admin-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={inputCls}
              placeholder="••••••••"
            />
          </div>
          <Button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-none bg-[#ba5a45] text-xs font-semibold uppercase tracking-widest text-[#f2efeb] hover:bg-[#9c4633]"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
          </Button>
        </form>
        <a href="/" className="mt-6 block text-center text-sm text-[#7a6c58] hover:text-[#a1a8a4]">
          ← Back to site
        </a>
      </div>
    </div>
  );
}
